import { isValid } from "date-fns";
import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import { FlatRowDatePicker } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePicker";
import { resolveDatePanelMode } from "web_myplann/Shared/Components/FlatRow/resolveDatePanelMode";
import { DateView } from "web_myplann/Shared/Types/DateView";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

type Props<
	FormType extends FieldValues,
	TName,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
	name: TName;
	label: string;
	views?: DateView[];
	displayFormat?: string;
	placeholder?: string;
	minDate?: Date;
	maxDate?: Date;
	isLast?: boolean;
	disabled?: boolean;
};

export const FlatRowFormDatePicker = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	label,
	views = [DateView.Year, DateView.Month],
	displayFormat = DateFormat.MonthYearLong,
	placeholder,
	minDate,
	maxDate,
	isLast,
	disabled,
}: Props<FormType, TName, TContext, TTransformed>) => (
	<Controller
		control={control}
		name={name}
		render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => {
			const rawValue = value as unknown;

			return (
				<FlatRowDatePicker
					label={label}
					value={
						rawValue instanceof Date && isValid(rawValue) ? rawValue : null
					}
					mode={resolveDatePanelMode(views)}
					displayFormat={displayFormat}
					placeholder={placeholder}
					minDate={minDate}
					maxDate={maxDate}
					onChange={onChange}
					onBlur={onBlur}
					isLast={isLast}
					disabled={disabled}
					error={Boolean(error?.message)}
					helperText={error?.message}
				/>
			);
		}}
	/>
);
